import { HoldbackType, HoldbackTypeValue } from '@/types/Holdbacks';
import { Box } from '@palmetto/palmetto-components';
import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';

import { DomesticContentTab } from './DomesticContent';
import { StandardHoldbacksTab } from './StandardHoldbacks/StandardHoldbacksTab';

const HoldbackSectionOption: Record<HoldbackTypeValue, ReactNode> = {
  [HoldbackType.standard]: <StandardHoldbacksTab />,
  [HoldbackType.domesticContent]: <DomesticContentTab />,
};

const isValidHoldbackType = (value: string | undefined): value is HoldbackTypeValue =>
  value === HoldbackType.standard || value === HoldbackType.domesticContent;

export const HoldbackSelfServiceTabOptions = () => {
  const { holdbackType } = useParams<{ holdbackType?: string }>();
  const resolvedHoldbackType: HoldbackTypeValue = isValidHoldbackType(holdbackType)
    ? holdbackType
    : HoldbackType.standard;

  return <Box margin="lg 0">{HoldbackSectionOption[resolvedHoldbackType]}</Box>;
};
